"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomUUID = void 0;
var uuid_1 = require("uuid");
function randomUUID() {
    if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) {
        return crypto.randomUUID();
    }
    else {
        return (0, uuid_1.v4)();
    }
}
exports.randomUUID = randomUUID;
